import React from 'react';

import { useQuery } from '@tanstack/react-query';

import DashboardDropdown from '../../DashboardDropdown';
import TitleDropdown from './TitleDropdown';

import classes from './styles.module.scss';
import AdminService from '../../../../../services/AdminService';

export default function DashboardHeader({
  // location,
  // setLocation,
  dateRange,
  setDateRange,
  company,
  setCompany,
  defaultCompanyOption,
  // defaultLocationOption,
  dashboardMode,
  setDashboardMode,
  dashboardModeOptions,
}) {
  const { data: locations } = useQuery({
    queryKey: ['locations', company?.value],
    queryFn: () => {
      const requestData = {
        pageSize: 9999,
      };

      if (company?.value) {
        requestData.Filters = `company.id:eq:${company.value}`;
      }

      return AdminService.getRestaurants(requestData);
    },
  });

  const { data: companies } = useQuery({
    queryKey: ['companies', locations],
    queryFn: () => AdminService.getCompanies({ pageSize: 9999 }),
  });

  // const locationOptions = locations
  //   ? locations?.data?.map((loc) => ({
  //       value: loc.id,
  //       label: loc.name,
  //       city: loc.city,
  //     }))
  //   : [];

  const companiesOptions = companies
    ? companies?.data?.map((cmp) => ({
        value: cmp.id,
        label: cmp.name,
      }))
    : [];

  // const locationOptionsWithDefaultValue = [
  //   defaultLocationOption,
  //   ...locationOptions,
  // ];

  const companiesOptionsWithDefaultValue = [
    defaultCompanyOption,
    ...companiesOptions,
  ];

  return (
    <header className={classes.DashboardHeader}>
      <TitleDropdown
        dashboardMode={dashboardMode}
        setDashboardMode={setDashboardMode}
        dashboardModeOptions={dashboardModeOptions}
      />
      <div className={classes.dropdowns}>
        <div className={classes.dropdownContainer}>
          <DashboardDropdown
            currentOption={company}
            setCurrentOption={setCompany}
            placeholder="Company"
            options={companiesOptionsWithDefaultValue}
            style={{ minWidth: 90 }}
            searchable
          />
        </div>
        {/* <div className={classes.dropdownContainer}>
          <DashboardDropdown
            currentOption={location}
            setCurrentOption={setLocation}
            placeholder="Location"
            options={locationOptionsWithDefaultValue}
          />
        </div> */}
        <div className={classes.dropdownContainer}>
          <DashboardDropdown
            currentOption={dateRange}
            setCurrentOption={setDateRange}
            placeholder="This month"
            calendar
          />
        </div>
      </div>
    </header>
  );
}
